// @ts-nocheck
export const signatureAcknowledgementMessage =
  'I acknowledge that the signature I have drawn above is the legal electronic representation of my signature.';

export const valueData: { [key: string]: { id: string; name: string } } = {
  Hour: {
    id: 'Hour',
    name: 'Hour',
  },
  Day: {
    id: 'Day',
    name: 'Day',
  },
  Week: {
    id: 'Week',
    name: 'Week',
  },
  Month: {
    id: 'Month',
    name: 'Month',
  },
};
export const dayRateOptions = [
  { id: 'Hour', name: 'Hour' },
  { id: 'Day', name: 'Day' },
  {
    id: 'Week',
    name: 'Week',
  },
  { id: 'Month', name: 'Month' },
];

export const MAX_COMMENT_LENGTH = 512;
